export const addOrUpdateSizeAndWeightInIncidentInputs = {
  axleLimitWeight: {
    name: "axleLimitWeight",
    accessId: false,
    hasMany: false
  },
  carrier: {
    name: "carrierId",
    accessId: true,
    hasMany: false
  },
  carrierAddress: {
    name: "carrierAddressId",
    accessId: true,
    hasMany: false
  },
  carrierPhone: {
    name: "carrierPhone",
    accessId: false,
    hasMany: false
  },
  cmvsChecked: {
    name: "cmvsChecked",
    accessId: false,
    hasMany: false
  },
  commodities: {
    name: "commodityIds",
    accessId: true,
    hasMany: true
  },
  courtAction: {
    name: "courtAction",
    accessId: false,
    hasMany: false
  },
  cvsaDecalsIssued: {
    name: "cvsaDecalsIssued",
    accessId: false,
    hasMany: false
  },
  dimensionViolationIdentified: {
    name: "dimensionViolationIdentified",
    accessId: false,
    hasMany: false
  },
  driverViolations: {
    name: "driverViolations",
    accessId: false,
    hasMany: false
  },
  endedAt: {
    name: "endedAt",
    accessId: false,
    hasMany: false
  },
  enforcementActivity: {
    name: "enforcementActivityId",
    accessId: true,
    hasMany: false
  },
  escreen: {
    name: "escreen",
    accessId: false,
    hasMany: false
  },
  fineTotal: {
    name: "fineTotal",
    accessId: false,
    hasMany: false
  },
  grossWeight: {
    name: "grossWeight",
    accessId: false,
    hasMany: false
  },
  height: {
    name: "height",
    accessId: false,
    hasMany: false
  },
  innerDimension: {
    name: "innerDimension",
    accessId: false,
    hasMany: false
  },
  issuedTo: {
    name: "issuedToId",
    accessId: true,
    hasMany: false
  },
  length: {
    name: "length",
    accessId: false,
    hasMany: false
  },
  location: {
    name: "locationId",
    accessId: true,
    hasMany: false
  },
  locked: {
    name: "locked",
    accessId: false,
    hasMany: false
  },
  lv1HazmatInspections: {
    name: "lv1HazmatInspections",
    accessId: false,
    hasMany: false
  },
  lv1Inspections: {
    name: "lv1Inspections",
    accessId: false,
    hasMany: false
  },
  lv2HazmatInspections: {
    name: "lv2HazmatInspections",
    accessId: false,
    hasMany: false
  },
  lv2Inspections: {
    name: "lv2Inspections",
    accessId: false,
    hasMany: false
  },
  lv3HazmatInspections: {
    name: "lv3HazmatInspections",
    accessId: false,
    hasMany: false
  },
  lv3Inspections: {
    name: "lv3Inspections",
    accessId: false,
    hasMany: false
  },
  lv4HazmatInspections: {
    name: "lv4HazmatInspections",
    accessId: false,
    hasMany: false
  },
  lv4Inspections: {
    name: "lv4Inspections",
    accessId: false,
    hasMany: false
  },
  lv5HazmatInspections: {
    name: "lv5HazmatInspections",
    accessId: false,
    hasMany: false
  },
  lv5Inspections: {
    name: "lv5Inspections",
    accessId: false,
    hasMany: false
  },
  lv6Inspections: {
    name: "lv6Inspections",
    accessId: false,
    hasMany: false
  },
  lv7Inspections: {
    name: "lv7Inspections",
    accessId: false,
    hasMany: false
  },
  lv8Inspections: {
    name: "lv8Inspections",
    accessId: false,
    hasMany: false
  },
  numberArrests: {
    name: "numberArrests",
    accessId: false,
    hasMany: false
  },
  numberOosDrivers: {
    name: "numberOosDrivers",
    accessId: false,
    hasMany: false
  },
  numberOosVehicles: {
    name: "numberOosVehicles",
    accessId: false,
    hasMany: false
  },
  numberVcvcsIssued: {
    name: "numberVcvcsIssued",
    accessId: false,
    hasMany: false
  },
  offloadRedistribution: {
    name: "offloadRedistribution",
    accessId: false,
    hasMany: false
  },
  operator: {
    name: "operatorId",
    accessId: true,
    hasMany: false
  },
  operatorAddress: {
    name: "operatorAddressId",
    accessId: true,
    hasMany: false
  },
  operatorPhone: {
    name: "operatorPhone",
    accessId: false,
    hasMany: false
  },
  otherWeighsCount: {
    name: "otherWeighsCount",
    accessId: false,
    hasMany: false
  },
  outerDimension: {
    name: "outerDimension",
    accessId: false,
    hasMany: false
  },
  owner: {
    name: "ownerId",
    accessId: true,
    hasMany: false
  },
  ownerAddress: {
    name: "ownerAddressId",
    accessId: true,
    hasMany: false
  },
  ownerPhone: {
    name: "ownerPhone",
    accessId: false,
    hasMany: false
  },
  permitNumberFiled: {
    name: "permitNumberFiled",
    accessId: false,
    hasMany: false
  },
  portableWeighsCount: {
    name: "portableWeighsCount",
    accessId: false,
    hasMany: false
  },
  powerUnit: {
    name: "powerUnitId",
    accessId: true,
    hasMany: false
  },
  platformOverUnder: {
    name: "platformOverUnder",
    accessId: false,
    hasMany: false
  },
  platformWeigh: {
    name: "platformWeigh",
    accessId: false,
    hasMany: false
  },
  platformWeighsCount: {
    name: "platformWeighsCount",
    accessId: false,
    hasMany: false
  },
  printCarrier: {
    name: "printCarrier",
    accessId: false,
    hasMany: false
  },
  printOwner: {
    name: "printOwner",
    accessId: false,
    hasMany: false
  },
  registeredWeight: {
    name: "registeredWeight",
    accessId: false,
    hasMany: false
  },
  roadLimitOverUnder: {
    name: "roadLimitOverUnder",
    accessId: false,
    hasMany: false
  },
  roadLimitWeight: {
    name: "roadLimitWeight",
    accessId: false,
    hasMany: false
  },
  roadType: {
    name: "roadTypeId",
    accessId: true,
    hasMany: false
  },
  semiPortableWeighsCount: {
    name: "semiPortableWeighsCount",
    accessId: false,
    hasMany: false
  },
  sizePermitsChecked: {
    name: "sizePermitsChecked",
    accessId: false,
    hasMany: false
  },
  startedAt: {
    name: "startedAt",
    accessId: false,
    hasMany: false
  },
  stateHighway: {
    name: "stateHighwayId",
    accessId: true,
    hasMany: false
  },
  steerAxleLimit: {
    name: "steerAxleLimit",
    accessId: false,
    hasMany: false
  },
  steerAxleTireSize: {
    name: "steerAxleTireSize",
    accessId: false,
    hasMany: false
  },
  supervisedInspections: {
    name: "supervisedInspections",
    accessId: false,
    hasMany: false
  },
  trailers: {
    name: "trailerIds",
    accessId: true,
    hasMany: true
  },
  triaxleDimension: {
    name: "triaxleDimension",
    accessId: false,
    hasMany: false
  },
  vehicleViolations: {
    name: "vehicleViolations",
    accessId: false,
    hasMany: false
  },
  violationIdentified: {
    name: "violationIdentified",
    accessId: false,
    hasMany: false,
  },
  width: {
    name: "width",
    accessId: false,
    hasMany: false,
  },
  wimsWeighsCount: {
    name: "wimsWeighsCount",
    accessId: false,
    hasMany: false,
  },
  weightMethods: {
    name: "weightMethodIds",
    accessId: true,
    hasMany: true
  },
  weightPermitsChecked: {
    name: "weightPermitsChecked",
    accessId: false,
    hasMany: false
  },
}